export default {
    'en': {
        currency: {

            style: 'currency', currency: 'USD'

        },
        decimal: {

            style: 'decimal'

        },
        fixed2: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },

    },
    'de': {

        currency: {

            style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'

        },
        decimal: {

            style: 'decimal'

        },
        fixed2: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },

    },
    'es': {

        currency: {

            style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'

        },
        decimal: {

            style: 'decimal'

        },
        fixed2: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },

    }
};
